/**
 * Manages property pins
 * @param map  the instance of the map the layer exists in
 * @param resultPropertyTooltipManager
 */
define(['jquery', 'c21/maps', 'c21/track'], function ($, C21Maps, track, InfinitePinScrollLayer) {
   "use strict";

   return function (map, resultPropertyTooltipManager) {
      var self = this,
         BingMaps = window.Microsoft.Maps,      
         m_aPinData = [],
         m_oPinById = {},
         m_pinDataById = {},      
         m_resultPropertyTooltipManager = resultPropertyTooltipManager,
                    
         m_layer = new BingMaps.Layer(),
         m_map = map,

         renderResultPin = function (image, text) {
            var c = document.createElement('canvas'),
               ratio = window.devicePixelRatio || 1,
               ctx = c.getContext('2d'),
               font = "bold 11px Arial, Helvetica, sans-serif";

            ratio = 1; // Have to intentionally disable retina scaling due to poor implementation of canvas in Bing

            var width = 49;
            var height = 32;
            c.width = width * ratio;
            c.height = height * ratio;
            c.style.width = width + 'px';
            c.style.height = height + 'px';
            ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

            var textAreaWidth = 41;
            var textTop = 16;
            var shadowXOffset = 1;
            var shadowYOffset = 1;

            if (image) {
               ctx.drawImage(image, 0, 0);
            }

            ctx.font = font;

            // Shadow
            ctx.fillStyle = '#fff';
            ctx.fillText(text, ((textAreaWidth - ctx.measureText(text).width) / 2) + shadowXOffset, textTop + shadowYOffset);

            // Text
            ctx.fillStyle = '#38383a';
            ctx.fillText(text, (textAreaWidth - ctx.measureText(text).width) / 2, textTop);

            return c.toDataURL();
         },

         createPin = function (pinData, loc) {
            var text = pinData.getShortPrice();
            var pin = new BingMaps.Pushpin(loc, {
               icon: renderResultPin(null, text),
               width: 50,
               height: 35,
               typeName: 'propertyPin',
               zIndex: C21Maps.getZindexFromLoc(
                  loc.latitude,
                  loc.longitude
               ),
               anchor: new BingMaps.Point(18, 34)
            });

            var image = new Image();
            image.onload = function () {
               pin.setOptions({
                  icon: renderResultPin(image, text)
               });
            };
            image.src = $(document.body).hasClass("pageEcoComm") ? '/images/eco/commercial/commercial_pin2.png' : '/images/eco/idx/mapping/property-pushpin-gold.png';

            C21Maps.onPinHoverIntent(m_map, pin, function () {
               track.doEvent('Hybrid Mapping', 'Property Map', 'Hover over a property on the map');
               m_resultPropertyTooltipManager.showHoverTooltip(pinData);
            }, function () {
               m_resultPropertyTooltipManager.hideHoverTooltip();
            });

            BingMaps.Events.addHandler(pin, 'click', function (e) {
               track.doEvent('Hybrid Mapping', 'Property Map', 'Click on a property on the map');
               m_resultPropertyTooltipManager.showClickTooltip(pinData);
            });

            return pin;
         },

         initialize = function () {
            m_layer.setZIndex(4);
            m_map.layers.insert(m_layer);
            C21Maps.onMapClick(m_map, function (e) {
               m_resultPropertyTooltipManager.clear();
            });
         };

      self.clearProperties = function () {
         m_layer.clear();
         m_aPinData = [];
         m_oPinById = {};
         m_pinDataById = {};
         m_resultPropertyTooltipManager.clear();
      };

      self.getProperties = function () {
         return m_aPinData;
      };

      self.setProperties = function (aPinData) {
         self.clearProperties();
         self.addProperties(aPinData);
      };

      self.addProperties = function (aPinData) {
         if (!m_aPinData) {
            self.setProperties(aPinData);
            return;
         }

         m_aPinData.concat(aPinData);
         $.each(aPinData, function (i, pinData) {
            if(pinData.getLatitude()) {
               var loc = pinData.getLocation(),
                  pin = createPin(pinData, loc),
                  id = pinData.getId();

               m_oPinById[id] = pin;
               m_pinDataById[id] = pinData;
               m_layer.add(pin);
            }
         });
      };

      initialize();
   };
});
